import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDetalheFerias } from '@core/models';
import { AppState } from '@store/store';

interface IDetalheFeriasState {
    data: IDetalheFerias;
    loading: boolean;
    error: string | null;
}

const initialState: IDetalheFeriasState = {
    data: {} as IDetalheFerias,
    error: null,
    loading: false
};

export const detalheFeriasSlice = createSlice({
    name: 'detalheFerias',
    initialState,
    reducers: {
        detalheFerias_fetching: (state) => {
            state.loading = true;
            state.data = {} as IDetalheFerias;
            state.error = null;
        },
        detalheFerias_success: (state, action: PayloadAction<IDetalheFerias>) => {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        },
        detalheFerias_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = {} as IDetalheFerias;
        }
    }
});

export const { detalheFerias_fetching, detalheFerias_success, detalheFerias_error } = detalheFeriasSlice.actions;

export const selectorDetalheFerias = (state: AppState) => state.detalheFerias;

export default detalheFeriasSlice.reducer;
